import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export function useDeletePlanejamento() {
  return useMutation(URL.PLANO_OPERACIONAL.DELETAR_PLANEJAMENTO("id"), async (id: string) => {
    const response = await http.delete(URL.PLANO_OPERACIONAL.DELETAR_PLANEJAMENTO(id));
    return response;
  });
}

export function useDeletePlanejamentoOperacao() {
  return useMutation(async ({ id, body }: { id: string; body: any }) => {
    const response = await http.delete(
      URL.PLANO_OPERACIONAL.DELETAR_PLANEJAMENTO_OPERACAO(id),
      { data: body }
    );
    return response;
  });
}

export function useDeletePlanejamentoOperacaoSingle() {
  return useMutation(URL.PLANO_OPERACIONAL.DELETAR_PLANEJAMENTO_OPERACAO("id"), async (id: string) => {
    const response = await http.delete(URL.PLANO_OPERACIONAL.DELETAR_PLANEJAMENTO_OPERACAO(id));
    return response;
  });
}

export function useDeletePlanejamentoSafraPeriodo() {
  return useMutation(async ({ id, body }: { id: string; body: any }) => {
    const response = await http.delete(
      URL.PLANO_OPERACIONAL.ATUALIZAR_SAFRA(id),
      { data: body }
    );
    return response;
  });
}